export class Address {
    id: number;
    street: string;
    street1?: any;
    city: string;
    state: string;
    zip: string;
    createdDate: Date;
    modifiedDate: Date;
}